import {createActions, createReducer} from 'reduxsauce'
import TripPriceService from './../../services/trip-price.service'

const initialState = {
    isLoading: false,
    fetchTimestamp: '',
    conversionParameters: []
}

const setFetchingData = (state = initialState, {fetchTimestamp}) => ({
    ...state,
    fetchTimestamp
})

const setData = (state = initialState, {data, fetchTimestamp}) => {
    const isSameRequest = state.fetchTimestamp == fetchTimestamp
    return {
        ...state,
        isLoading: !isSameRequest,
        conversionParameters: isSameRequest
            ? data.data
            : state.conversionParameters
    }
}

const fetchData = () => dispatch => {
    const timestamp = +new Date()
    dispatch(Creators.setFetchingData(timestamp))
    return TripPriceService
        .getConversionParameters()
        .then(data => dispatch(Creators.setData(data, timestamp)))
}

export const {
    Types,
    Creators
} = createActions({
    fetchData,
    setFetchingData: ['fetchTimestamp'],
    setData: ['data', 'fetchTimestamp']
}, {prefix: 'trip-price/'})

export default createReducer(initialState, {
    [Types.SET_DATA]: setData,
    [Types.SET_FETCHING_DATA]: setFetchingData
})
